const { version, name } = require('../../package.json');
export const environment = {
  production: true,
  API_ENDPOINT: 'https://api.sitenotesapp.com',
  GOOGLE_MAPS_API_KEY: 'AIzaSyAh3sGhzoV8YDk4PnLHEiq5CKQfzhBaPMk',
  ESRI_MAPS_API_KEY: 'AAPTxy8BH1VEsoebNVZXo8HurKtgi3n7C2PMMvf-uA_dStWWChG3pS01LEFBFn1r_e2NaezRJkcz8hhRSne904Z3KoXvmhPa9R6U3zNS3z676TkkiGosBWiw9q85YYdX-MatTUXZCuPrhL4PBOryGeJBZ3-PcNyDrPmpRmbWKXVwrBwTq4lmX9awv1ghvu7Y0hYjwWHfTCpud6yOe8Pr4BH30DXMVmD54yIwSqfusLl1yewEguTp-192HMihEEv2LtUzAT1_H6asjURI',
  ESRI_BASEMAP_PORTAL_ID: 'ad49b8d712cd4bbfbaf66c2dbfade433',
  SENTRY_DSN: 'https://7f47f6cc676c4d30bdda9798603d66d8@o456313.ingest.us.sentry.io/5449228',
  SENTRY_ENVIRONMENT: 'production',
  AUTOSAVE_DEBOUNCE: 1500,
  APP_VERSION: version,
  APP_NAME: name,
  POSTHOG_API_KEY: 'phc_fDe6FTgwkXIk8JsvqOx8s1LISaCEbE0i9VWrKIhJHNc',
  POSTHOG_HOST: 'https://us.i.posthog.com',
  APP_ENV: 'production' as const,
};
